import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContentText,
  Divider,
  makeStyles,
} from "@material-ui/core";
import { DialogTitle } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  flexColContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flexColItem: {
    margin: theme.spacing(1, 0, 0, 0),
  },
  feedback: {
    maxHeight: "160px",
  },
}));

const EntityForm = ({
  title,
  columns,
  initialData,
  entityDefinition,
  onSubmit,
  disabledColumns,
  ...rest
}) => {
  const classes = useStyles();
  const [formData, setFormData] = useState(initialData);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (fieldName, fieldValue) => {
    const newFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(newFormData);
  };

  return (
    <Dialog fullWidth maxWidth="sm" {...rest}>
      <DialogTitle>{title}</DialogTitle>

      <Divider />

      <DialogContent className={classes.flexColContainer}>
        {columns.map((col) =>
          entityDefinition[col].inputComponent({
            key: col,
            className: classes.flexColItem,
            name: col,
            label: entityDefinition[col].displayName,
            value: formData[col],
            onUpdate: handleChange,
            error: !entityDefinition[col].isValid(formData),
            // fullWidth: true,
            InputLabelProps: {
              shrink: true,
            },
            disabled: disabledColumns.includes(col),
          })
        )}
      </DialogContent>

      {errorMessage !== "" ? (
        <Box border={1} borderRadius={4} borderColor={"error.main"}>
          <DialogContent className={classes.feedback}>
            <DialogContentText>{errorMessage}</DialogContentText>
          </DialogContent>
        </Box>
      ) : (
        <Divider />
      )}

      <DialogActions>
        <Button color="secondary" variant="contained" onClick={rest.onClose}>
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={columns
            .map((col) => entityDefinition[col].isValid(formData))
            .includes(false)}
          onClick={() => onSubmit(formData, rest.onClose, setErrorMessage)}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EntityForm;

EntityForm.propTypes = {
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabledColumns: PropTypes.arrayOf(PropTypes.string),
  initialData: PropTypes.object,
  entityDefinition: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

EntityForm.defaultProps = {
  disabledColumns: [],
};
